import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';

import { DEFAULT_SINGLE_EXPERIMENT_SAMPLE_SIZE } from '@/lib/appConstants';
import { ExperimentTemplateData } from '@experiment-details/types';
import { generateAutoGeneratedMetricsPanel } from '@experiment-management-shared';
import { LayoutWorker } from '@experiment-management-shared/components/Charts/workers';

export const EXPERIMENT_DETAILS_SAMPLE_SIZES = sortBy(
  uniq([DEFAULT_SINGLE_EXPERIMENT_SAMPLE_SIZE, 50, 150, 500, 10000])
).map(value => ({
  isDefault: DEFAULT_SINGLE_EXPERIMENT_SAMPLE_SIZE === value,
  value
}));

type AddAutoGeneratedPanelsArgs = {
  template: ExperimentTemplateData;
  metricNames: string[];
};

export const addAutoGeneratedMetricPanels = async ({
  template,
  metricNames
}: AddAutoGeneratedPanelsArgs): Promise<ExperimentTemplateData> => {
  const autoGeneratedMetricsPanels = metricNames.map(
    generateAutoGeneratedMetricsPanel
  );

  return {
    ...template,
    chartTemplate: {
      ...template.chartTemplate,
      panels: {
        ...template.chartTemplate.panels,
        sections: await LayoutWorker.mergeMetricsWithAutogeneratedPanels({
          autoGeneratedMetricsPanels,
          initialSections: template.chartTemplate.panels.sections
        })
      }
    }
  };
};
